import Vue from "vue";
import Logo from './logo';
Vue.component("a-logo", Logo);
